	export enum UnavailableSlotApplyToTypeEnum {
		OnlyProvider = 1,
		OnlyResource = 2,
		Clinic = 3
	}
